// Game-wide constants. Values come from the design doc (Wizard Poker - 2.pdf)
// and the creator's answers. Change them here only.

export const MAX_SEATS = 6;
export const MIN_PLAYERS_TO_START = 2;

/**
 * Default seconds a player has to act (new lobbies start with this, via
 * DEFAULT_LOBBY_SETTINGS in protocol.ts). Host can change per lobby.
 */
export const DEFAULT_TURN_SECONDS = 30;
export const MIN_TURN_SECONDS = 10;
export const MAX_TURN_SECONDS = 120;

/**
 * Community cards stay face-up this long, then flip face-down (default for new
 * lobbies, via DEFAULT_LOBBY_SETTINGS). Host can change per lobby.
 */
export const DEFAULT_REVEAL_SECONDS = 5;
export const MIN_REVEAL_SECONDS = 1;
export const MAX_REVEAL_SECONDS = 15;

/** Largest per-lobby hand limit a host can set (null = unlimited). */
export const MAX_HAND_LIMIT = 500;

/**
 * How long the showdown / hand result stays on screen before the hand is
 * final and paid. Spells and reports still work during it (creator's rule).
 */
export const RESULT_DISPLAY_SECONDS = 10;

/** Lobby closes when nobody has been active for this long. */
export const LOBBY_IDLE_MS = 15 * 60 * 1000;

/** Client sends a heartbeat this often; server drops sockets silent for 3x this. */
export const HEARTBEAT_MS = 10_000;

export const MAX_HEALTH = 100;
export const MAX_MANA = 100;
/**
 * Mana refills to full (MAX_MANA) at the start of every hand. Kept as a
 * constant for older UI text; equal to MAX_MANA.
 */
export const MANA_REGEN_PER_HAND = MAX_MANA;
/** Overcharge mana can push a player above MAX_MANA by at most this much. */
export const MAX_OVERCHARGE = 98;
/**
 * Hard cap of a player's overcharge: the Overcharge spell fills it up to
 * MAX_OVERCHARGE, and Blight can push the receiver up to 20 more (20% of at
 * most 100 juice drained).
 */
export const MAX_OVERCHARGE_TOTAL = MAX_OVERCHARGE + MAX_MANA / 5;

export const USERNAME_MIN = 1;
export const USERNAME_MAX = 30;
export const PASSWORD_MIN = 8;
export const PASSWORD_MAX = 128;
export const LOBBY_NAME_MIN = 1;
export const LOBBY_NAME_MAX = 40;
export const LOBBY_PASSWORD_MIN = 1;
export const LOBBY_PASSWORD_MAX = 50;
export const DISPLAY_NAME_MIN = 1;
export const DISPLAY_NAME_MAX = 30;
export const EMAIL_MAX = 254;

/** Short codes for joining a lobby by hand. No 0/O/1/I/L to avoid mix-ups. */
export const ROOM_CODE_LENGTH = 6;
export const ROOM_CODE_ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";

/** Username reserved for the main admin account (created from the ADMIN_SEED secret). */
export const MAIN_ADMIN_USERNAME = "SkunkMonk";
